// @flow

export const SETTINGS_USERS_INFO_READY = 'SETTINGS_USERS_INFO_READY'
export const SETTINGS_USERS_LIST_READY = 'SETTINGS_USERS_LIST_READY'
export const SETTINGS_USERS_NOTIFICATION = 'SETTINGS_USERS_NOTIFICATION'
export const PROFILE_INFO_REMOVE_COMPLETED = 'PROFILE_INFO_REMOVE_COMPLETED'
export const PROFILE_INFO_RESTORE_COMPLETED = 'PROFILE_INFO_RESTORE_COMPLETED'
export const SETTINGS_USERS_RESET = 'SETTINGS_USERS_RESET'
